import {React, Component} from "react";

class notpage extends Component{
    dahboardclick =()=>{
        this.props.history.push({pathname : "/dashboard"})
    }
    render(){
        return(
            <div style={{textAlign:"center"}}>
            <div  className="col-12">
          <img className="img-fluid"  src={process.env.REACT_APP_ENV +"/assets/images/404/404_New.png"} alt="View" />
          </div>
           <div><button className="btn btn-lg btn-primary mt-3"  onClick={this.dahboardclick}>Go to Dashboard</button></div>
           </div>
        )
    }
}


export default notpage